import React from 'react';
import { Check } from 'lucide-react';

const InfoSection = () => {
  return (
    <section id="info" className="py-16 md:py-20 bg-slate-950" data-testid="info-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Metal Trusses Section */}
        <div className="mb-16">
          <div className="glass-card p-6 md:p-8">
            <div className="max-w-4xl mx-auto space-y-4">
              <h2
                className="text-3xl md:text-4xl font-semibold tracking-tight mb-4 uppercase text-orange-500 text-center"
                style={{ fontFamily: 'Rajdhani, sans-serif' }}
                data-testid="trusses-title"
              >
                3D Metal Trusses: Fast, Strong, and Cost-Effective
              </h2>
              
              <p className="text-xl leading-relaxed text-slate-300">
                An increasing number of businesses undertaking construction projects are making the switch from wooden 
                trusses to cold-formed steel trusses — a far more durable, efficient, and economical choice.
              </p>

              <p className="text-xl leading-relaxed text-slate-300">
                Cold-formed steel trusses with 3D METAL offer significantly shorter installation times and lower overall 
                project costs compared to conventional wood truss systems. This material combines strength, stability, and 
                sustainability, making it one of <span className="text-xl font-medium">the most advanced construction solutions available today</span>.
              </p>

              <p className="text-xl leading-relaxed text-slate-300">
                At <span className="text-orange-500 font-semibold">3D METAL HOME BUILDING</span>, we provide high-quality 
                steel truss systems that deliver performance, precision, and peace of mind. Whether you're seeking non-combustible 
                materials, long-lasting durability, or an eco-friendly alternative, our cold-formed steel trusses provide the 
                perfect foundation for your construction goals.
              </p>
            </div>
          </div>
        </div>

        {/* Light Gauge Steel Section */}
        <div className="mb-10 text-center">
          <h2
            className="text-3xl md:text-4xl font-semibold tracking-tight mb-3 uppercase text-orange-500"
            style={{ fontFamily: 'Rajdhani, sans-serif' }}
            data-testid="residential-title"
          >
            Light Gauge Steel Residential Construction
          </h2>
          <p className="text-xl md:text-2xl text-orange-500 font-semibold mb-3" style={{ fontFamily: 'Rajdhani, sans-serif' }}>
            We are Building Better Homes with 3D METAL
          </p>
          <p className="text-xl text-slate-300 leading-relaxed">
            Steel is stronger, more stable, and straighter than lumber.
          </p>
        </div>

        {/* Benefits List */}
        <div>
          <h3
            className="text-2xl font-semibold tracking-tight mb-6 uppercase text-center text-orange-500"
            style={{ fontFamily: 'Rajdhani, sans-serif' }}
            data-testid="benefits-title"
          >
            Benefits for Residential and Commercial Use
          </h3>
          
          <div className="max-w-4xl mx-auto space-y-3">
            <div className="flex items-start space-x-3">
              <Check className="text-orange-500 flex-shrink-0 mt-1" size={20} />
              <p className="text-xl text-white leading-relaxed">
                <span className="font-bold">Using 3D METAL Save 10% to 20% over wood on total cost</span>
              </p>
            </div>

            <div className="flex items-start space-x-3">
              <Check className="text-orange-500 flex-shrink-0 mt-1" size={20} />
              <p className="text-xl text-white leading-relaxed">
                <span className="font-bold">Once we receive approved plans we will make your frames in 1 day</span>
              </p>
            </div>

            <div className="flex items-start space-x-3">
              <Check className="text-orange-500 flex-shrink-0 mt-1" size={20} />
              <p className="text-xl text-white leading-relaxed">
                <span className="font-bold">The second day we will Assemble all of the frames in sections</span>
              </p>
            </div>

            <div className="flex items-start space-x-3">
              <Check className="text-orange-500 flex-shrink-0 mt-1" size={20} />
              <p className="text-xl text-white leading-relaxed">
                <span className="font-bold">The third day we will deliver to job site</span>
              </p>
            </div>

            <div className="flex items-start space-x-3">
              <Check className="text-orange-500 flex-shrink-0 mt-1" size={20} />
              <p className="text-xl text-white leading-relaxed">
                <span className="font-bold">The fourth day if you want we will start framing 2 to 3 days only</span>
              </p>
            </div>

            <div className="flex items-start space-x-3">
              <Check className="text-orange-500 flex-shrink-0 mt-1" size={20} />
              <p className="text-xl text-white leading-relaxed">
                <span className="font-bold">We can have your job 100% framed from start to finish in 5 days</span>
              </p>
            </div>

            <div className="flex items-start space-x-3">
              <Check className="text-orange-500 flex-shrink-0 mt-1" size={20} />
              <p className="text-xl text-white leading-relaxed">
                <span className="font-bold">Lower Insurance rates by 15 to 40%</span>
              </p>
            </div>

            <div className="flex items-start space-x-3">
              <Check className="text-orange-500 flex-shrink-0 mt-1" size={20} />
              <p className="text-xl text-white leading-relaxed">
                <span className="font-bold">No more wood waste and 80% less trash haul</span>
              </p>
            </div>

            <div className="flex items-start space-x-3">
              <Check className="text-orange-500 flex-shrink-0 mt-1" size={20} />
              <p className="text-xl text-white leading-relaxed">
                <span className="font-bold">Withstand 180 mph winds and Fire resistance</span>
              </p>
            </div>

            <div className="flex items-start space-x-3">
              <Check className="text-orange-500 flex-shrink-0 mt-1" size={20} />
              <p className="text-xl text-white leading-relaxed">
                <span className="font-bold">No more termites or mold</span>
              </p>
            </div>

            <div className="flex items-start space-x-3">
              <Check className="text-orange-500 flex-shrink-0 mt-1" size={20} />
              <p className="text-xl text-white leading-relaxed">
                <span className="font-bold">Hybrid material projects</span> - Withstand 180 mph winds
              </p>
            </div>
          </div>

          {/* Video Section */}
          <div className="mt-12 max-w-4xl mx-auto">
            <div className="glass-card p-4">
              <div className="aspect-video w-full">
                <iframe
                  width="100%"
                  height="100%"
                  src="https://www.youtube.com/embed/XX599W7CALc"
                  title="YouTube video"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="rounded"
                ></iframe>
              </div>
            </div>
          </div>
        </div>

        {/* Cold-Formed Steel & Storms Section */}
        <div className="mt-20">
          <div className="glass-card p-6 md:p-8">
            <div className="max-w-4xl mx-auto space-y-6">
              <h2
                className="text-3xl md:text-4xl font-semibold tracking-tight mb-6 uppercase text-orange-500 text-center"
                style={{ fontFamily: 'Rajdhani, sans-serif' }}
                data-testid="storms-title"
              >
                3D Metal Cold-Formed Steel & Storms
              </h2>

              <div className="text-center mb-6">
                <p className="text-xl text-orange-500 font-semibold" style={{ fontFamily: 'Rajdhani, sans-serif' }}>
                  Grounded against an electrical storm
                </p>
              </div>
              
              <p className="text-xl leading-relaxed text-slate-300">
                Cold-formed steel is resistant to issues such as corrosion, mold, and pests, minimizing the necessity for expensive treatments or repairs.
              </p>

              <div className="space-y-4">
                <div>
                  <h3 className="text-xl font-semibold text-orange-500 mb-2" style={{ fontFamily: 'Rajdhani, sans-serif' }}>
                    Dimensional Stability
                  </h3>
                  <p className="text-xl leading-relaxed text-slate-300">
                    The dimensional stability of cold-formed steel is unparalleled, exhibiting no moisture-induced expansion or contraction that might lead to unintended structural shifts. The steel maintains consistent strength and dimensional characteristics in all directions, creating a tight envelope that enhances energy efficiency while lowering maintenance and repair expenses.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-orange-500 mb-2" style={{ fontFamily: 'Rajdhani, sans-serif' }}>
                    Durability
                  </h3>
                  <p className="text-xl leading-relaxed text-slate-300">
                    Light gauge cold-formed steel is treated with galvanization, rendering it exceptionally durable and resistant to rust and corrosion. This results in structures designed to endure for generations, with nearly flawless walls, trusses, joists, and beams functioning as intended. The dimensional stability of cold-formed steel framing offers considerable cost savings throughout the construction project lifecycle, establishing it as a safer and more stable option for any building endeavor.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-orange-500 mb-2" style={{ fontFamily: 'Rajdhani, sans-serif' }}>
                    Cold-Formed Steel & Storms
                  </h3>
                  <p className="text-xl leading-relaxed text-slate-300">
                    Grounded against electrical storms, our cold-formed steel structures provide superior protection and peace of mind in all weather conditions.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Steel Frame Sizes Section */}
        <div className="mt-20">
          <div className="glass-card p-6 md:p-8">
            <div className="max-w-4xl mx-auto space-y-6">
              <h2
                className="text-3xl md:text-4xl font-semibold tracking-tight mb-6 uppercase text-orange-500 text-center"
                style={{ fontFamily: 'Rajdhani, sans-serif' }}
                data-testid="steel-frame-sizes-title"
              >
                Steel Frame Sizes
              </h2>

              <p className="text-xl leading-relaxed text-slate-300 text-center">
                Our machines have 3 sizes of metal frames. Our machines print a different size for each one.
              </p>

              <div className="space-y-4 mt-6">
                <div className="flex items-start space-x-3">
                  <span className="text-orange-500 text-2xl mt-0.5">&#8226;</span>
                  <p className="text-xl leading-relaxed text-slate-300">
                    <span className="text-orange-500 font-semibold">140mm (5.5in) Panel Machine</span> – External walls & party walls between units
                  </p>
                </div>

                <div className="flex items-start space-x-3">
                  <span className="text-orange-500 text-2xl mt-0.5">&#8226;</span>
                  <p className="text-xl leading-relaxed text-slate-300">
                    <span className="text-orange-500 font-semibold">90mm (3.5in) Panel Machine</span> – Internal walls
                  </p>
                </div>

                <div className="flex items-start space-x-3">
                  <span className="text-orange-500 text-2xl mt-0.5">&#8226;</span>
                  <p className="text-xl leading-relaxed text-slate-300">
                    <span className="text-orange-500 font-semibold">RF600 (2.0in) Truss</span> – Floors & Roof trusses
                  </p>
                </div>
              </div>

              <div className="mt-6 pt-4 border-t border-slate-700">
                <h3 className="text-xl font-semibold text-orange-500 mb-2" style={{ fontFamily: 'Rajdhani, sans-serif' }}>
                  Materials Summary
                </h3>
                <p className="text-xl leading-relaxed text-slate-300">
                  Using the panel is 90 and 140 series machines and a 600 series truss machine.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InfoSection;
